import {Country} from "../../entities";

export const GetCountryMatrix = ():Country[] => {
  return window.calcConfig.matrix?.countries ?? []
}
